import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import en from './locales/en.json'
import ja from './locales/ja.json'

// If no language is cached, default to Japanese
if (typeof window !== 'undefined' && !localStorage.getItem('i18nextLng')) {
  localStorage.setItem('i18nextLng', 'ja')
}

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      ja: { translation: ja },
    },
    fallbackLng: 'ja',
    interpolation: { escapeValue: false, prefix: '{', suffix: '}' },
  })

export default i18n
